import { render, staticRenderFns } from "./iframePowerBI.vue?vue&type=template&id=2ce6bae5&scoped=true&"
import script from "./iframePowerBI.vue?vue&type=script&lang=js&"
export * from "./iframePowerBI.vue?vue&type=script&lang=js&"
import style0 from "./iframePowerBI.vue?vue&type=style&index=0&id=2ce6bae5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce6bae5",
  null
  
)

export default component.exports